import { withInstall } from '@ll-plus/utils'

import Upload from './src/upload.vue'

export const LlUpload = withInstall(Upload)
export default LlUpload
export * from './src/upload'

declare module 'vue' {
  export interface GlobalComponents {
    LlUpload: typeof Upload
  }
}
